import React from "react";
import { CtaButton } from "./CtaButton";
type SectionProps = {
  children: React.ReactNode;
  tone?: "cream" | "sand" | "white" | "ink";
  cta?: string;
  ctaCaption?: string;
  id?: string;
  narrow?: boolean;
};
const toneClass = {
  cream: "bg-cream",
  sand: "bg-sand",
  white: "bg-white",
  ink: "bg-ink text-white"
};
export function Section({
  children,
  tone = "cream",
  cta,
  ctaCaption,
  id,
  narrow
}: SectionProps) {
  return <section id={id} className={`w-full px-5 py-16 md:py-24 ${toneClass[tone]}`} data-id="element-55" data-mp="cgghf265d28t">
      <div className={`mx-auto ${narrow ? "max-w-3xl" : "max-w-5xl"}`} data-id="element-56" data-mp="hdgcyj5demlo">
        {children}
        {cta && <div className="mt-12" data-id="element-57" data-mp="2pc0vy0tp9bv">
            <CtaButton label={cta} caption={ctaCaption} data-id="element-58" data-mp="7oygge44j1nu" />
          </div>}
      </div>
    </section>;
}
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  light?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  light
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-59" data-mp="2zlmztfqzmrdb">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] ${light ? "text-roseSoft" : "text-rose"}`} data-id="element-60" data-mp="2um0o5aqt5j6m">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[30px] font-bold leading-[1.12] md:text-5xl ${light ? "text-white" : "text-ink"}`} data-id="element-61" data-mp="38e6uk545sbsv">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-[17px] leading-relaxed md:text-lg ${light ? "text-white/80" : "text-inkSoft"}`} data-id="element-62" data-mp="3icwd803vq0a6">
          {subtitle}
        </p>}
    </div>;
}